// Homepage "day of light" behaviour: the hero sky follows the visitor's
// local time, the matching window of the day is highlighted, and the
// planner sliders re-sketch the day. Markup lives in template-parts/hero.php,
// rhythm.php and planner.php; every colour here is a CSS expression built
// from the Customizer-backed variables (see _variables.scss), never a hex.
document.addEventListener("DOMContentLoaded", () => {
  const sky = document.querySelector(".js-sky");
  const slotEls = Array.from(document.querySelectorAll(".js-slot"));

  // ─── Sky + sun/moon + "right now" ──────────────────────────────────────────
  if (sky && slotEls.length) {
    const slots = slotEls.map((el) => ({
      el,
      from: Number(el.dataset.from),
      to: Number(el.dataset.to),
      icon: el.dataset.icon || "",
      name: el.dataset.name || "",
      text: (el.querySelector(".slot__text") || {}).textContent || "",
    }));

    // [start hour, top colour, bottom colour, isDark]
    const SKY = [
      [0, "var(--sky-midnight-a)", "var(--sky-midnight-b)", true],
      [5, "var(--sky-predawn-a)", "var(--sky-predawn-b)", true],
      [7, "var(--sky-morning-a)", "var(--sky-morning-b)", false],
      [11, "var(--sky-day-a)", "var(--sky-day-b)", false],
      [16, "var(--sky-afternoon-a)", "var(--sky-afternoon-b)", false],
      [19, "var(--sky-dusk-a)", "var(--sky-dusk-b)", true],
      [21, "var(--sky-evening-a)", "var(--sky-evening-b)", true],
    ];

    const orb = sky.querySelector(".js-orb");
    const now = sky.querySelector(".js-now");
    const nowLabel = sky.dataset.nowLabel || "";

    const slotFor = (hour) => {
      const h = hour < 6 ? hour + 24 : hour;
      return slots.find((s) => h >= s.from && h < s.to) || slots[slots.length - 1];
    };

    const paint = () => {
      const d = new Date();
      const h = d.getHours() + d.getMinutes() / 60;

      let k = 0;
      SKY.forEach((stop, i) => {
        if (h >= stop[0]) k = i;
      });
      const [, top, bottom, dark] = SKY[k];
      sky.style.setProperty("--sky-top", top);
      sky.style.setProperty("--sky-bottom", bottom);
      sky.classList.toggle("is-dark", dark);
      document.body.classList.toggle("sky-dark", dark);

      if (orb) {
        const isDay = h >= 6 && h < 19.5;
        orb.classList.toggle("is-sun", isDay);
        orb.classList.toggle("is-moon", !isDay);
        const f = isDay ? (h - 6) / 13.5 : ((h < 6 ? h + 24 : h) - 19.5) / 10.5;
        orb.style.left = 8 + f * 84 + "%";
        orb.style.top = 70 - Math.sin(f * Math.PI) * 52 + "%";
      }

      const current = slotFor(Math.floor(h));
      slots.forEach((s) => s.el.classList.toggle("is-now", s === current));

      if (now) {
        now.querySelector(".js-now-icon").textContent = current.icon;
        now.querySelector(".js-now-title").textContent = nowLabel ? nowLabel + " · " + current.name : current.name;
        now.querySelector(".js-now-text").textContent = current.text;
        now.hidden = false;
      }
    };

    paint();
    setInterval(paint, 30000);
  }

  // ─── Planner ───────────────────────────────────────────────────────────────
  const planner = document.querySelector(".js-planner");
  if (planner) {
    let data;
    try {
      data = JSON.parse(planner.dataset.planner);
    } catch (e) {
      return;
    }

    const wake = planner.querySelector(".js-wake");
    const sleep = planner.querySelector(".js-sleep");
    const wakeValue = planner.querySelector(".js-wake-value");
    const sleepValue = planner.querySelector(".js-sleep-value");
    const list = planner.querySelector(".js-plan");

    const fmt = (m) => {
      m = ((m % 1440) + 1440) % 1440;
      const h = Math.floor(m / 60);
      const mm = m % 60;
      return (h % 12 || 12) + ":" + String(mm).padStart(2, "0") + " " + (h < 12 ? "am" : "pm");
    };

    const el = (tag, text, className) => {
      const node = document.createElement(tag);
      node.textContent = text;
      if (className) node.className = className;
      return node;
    };

    const render = () => {
      const w = Number(wake.value);
      const hours = Number(sleep.value);
      const bed = w - hours * 60;

      wakeValue.textContent = fmt(w);
      sleepValue.textContent = hours + " " + data.hours;

      list.replaceChildren(
        ...data.rows.map((row) => {
          const li = document.createElement("li");
          const body = document.createElement("div");
          body.append(el("strong", row.title), el("span", row.text.replace("%s", hours)));
          li.append(el("div", fmt((row.base === "w" ? w : bed) + row.off), "planner__time"), body);
          return li;
        })
      );
    };

    wake.addEventListener("input", render);
    sleep.addEventListener("input", render);
    render();
  }
});
